

export default (state = [], action) => {
  if (action.type == "SET_HORAIRE") {
    return action.value;
  }
  return state;
};